import React from "react";

const mapContainerStyle = {
  width: "100%",
  height: "450px",
  border: "0",
};

const wrapperStyle = {
  maxWidth: "800px",
  margin: "0 auto",
  borderRadius: "12px",
  overflow: "hidden",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  backgroundColor: "transparent",
};

const mapUrl =
  "https://www.google.com/maps?q=39.9961683676999,32.751700104592146&z=15&output=embed";

const MapSection = () => {
  return (
    <section className="bg-gray-50 py-12 px-4">
      <div className="container mx-auto max-w-5xl space-y-10">

        {/* ABOUT US */}
        <div className="mb-20 px-4 pt-24">
          <h2 className="text-3xl font-bold mb-6 text-center text-gray-800">
            About Us
          </h2>

          <p className="mb-4 text-gray-700 leading-relaxed">
            Kristal Fotonik is an imaging-technology company headquartered in
            Ankara, Turkey. We engineer innovative camera modules and edge-AI
            image-processing systems that transform raw pixels into real-time,
            decision-ready data—whether they orbit on satellites, watch an
            assembly line or power a smart-city pole.
          </p>

          <p className="mb-4 text-gray-700 leading-relaxed">
            <strong>Mission</strong> – Make advanced vision simple. We deliver
            plug-and-play imaging solutions that boost efficiency, safety and
            insight for organisations of every size.
          </p>

          <p className="mb-4 text-gray-700 leading-relaxed">
            <strong>Vision</strong> – Enable machines to perceive the world as
            clearly as humans do. By pushing the boundaries of optics,
            embedded compute and artificial intelligence, we aim to lead the
            transition toward fully autonomous, vision-driven systems across
            industry and society.
          </p>

          <p className="mb-4 text-gray-700 leading-relaxed">
            <strong>What Sets Us Apart</strong>
          </p>

          <ul className="list-disc list-inside mb-4 text-gray-700">
            <li>
              Full-stack know-how – optics, electronics, embedded firmware &
              software and AI all under one roof, so integrations happen
              without friction.
            </li>

            <li>
              Scalable design – modular hardware and flexible firmware let
              customers move smoothly from prototype to volume production.
            </li>

            <li>
              Agile culture – a focused team that delivers solutions in a
              short amount of time.
            </li>

            <li>
              Partnership mindset – we deliver complete solutions, tailoring
              algorithms, hardware configurations and support to each
              application instead of offering one-size-fits-all products.
            </li>
          </ul>

          <p className="mb-4 text-gray-700 leading-relaxed">
            <strong>Quality Standard</strong>
            <br />
            We back our products with rigorous supplier vetting, 100 %
            functional testing, environmental stress and thermal-mechanical
            validation before shipment. All processes comply with CE, RoHS
            and ISO 9001 requirements, and each project feeds a
            continuous-improvement loop that keeps our quality benchmark
            moving forward.
          </p>
        </div>

        {/* MAP */}
        <div style={wrapperStyle}>
          <iframe
            src={mapUrl}
            title="Kristal Fotonik location on Google Maps"
            width="100%"
            height="450"
            style={mapContainerStyle}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        {/* COMPANY INFORMATION */}
        <div className="text-center mt-10 text-gray-800 space-y-2">
          <h3 className="text-2xl font-semibold">
            Kristal Fotonik
          </h3>

          <p className="text-lg">
            📞 +90 555 223 01 62
          </p>

          <p className="text-md">
            📍 İvedik OSB 2224. Avenue No: 1/110 Yenimahalle / Ankara
          </p>
        </div>

      </div>
    </section>
  );
};

export default MapSection;